var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGeneralAgent = function SvgGeneralAgent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M16.236 3q.41 0 .688.275a.93.93 0 0 1 .277.684.94.94 0 0 1-.277.688.93.93 0 0 1-.688.282h-.963v3.843l5.383 9.12q.75.939.214 2.023Q20.335 21 19.13 21H4.986q-1.231 0-1.767-1.085t.24-2.027l5.385-9.116V4.93h-.96a.95.95 0 0 1-.688-.276.92.92 0 0 1-.28-.683q0-.408.276-.689A.93.93 0 0 1 7.88 3zm-5.463 6.415-.38.633a.3.3 0 0 0-.067.068L5.244 18.12a.25.25 0 0 0 .14.374l.071.01H18.55l.07-.01a.25.25 0 0 0 .142-.373l-4.988-8.003a.3.3 0 0 0-.035-.042l-.395-.661V4.929h-2.571zm6.875 8.339H6.364l1.099-1.732c4.192-.277 2.844-2.082 7.478-2.612z"
  })));
};
export default SvgGeneralAgent;